// AUTO-GENERATED once from insurance-checker/proforma-generator (products.py +
// config.py), 2026-06-17. One-time migration export: from here on THIS file is the
// source of truth and products.py retires. Not a sync target — edit directly.

export type CatalogLine = (string | number)[] // [tarif,tarifziffer,bez,anzahl,tp_al,f_al,tpw_al,tp_tl,f_tl,tpw_tl,betrag]
export interface CatalogService {
  label: string
  label_en: string
  tardoc_total: number
  lines: CatalogLine[]
}
export interface CatalogPackage {
  label: string
  cover_products: string[]
  tardoc_services: string[]
}
export interface CatalogData {
  PRODUCT_SERVICES: Record<string, CatalogService>
  PACKAGES: Record<string, CatalogPackage>
  ADDONS: Record<string, { cover: string; tardoc: string }>
  BLOOD_TEST_SERVICES: string[]
  TARDOC_ORDER: string[]
  MEMBERSHIP_FOLLOWUP_COUNTS: Record<string, number>
  FOLLOWUP_TARDOC_SERVICE: string
  GENDER_RULES: Record<
    string,
    { tardoc_swap: Record<string, string>; exclude: string[] }
  >
  PRODUCT_PRICES: Record<
    string,
    // member_price: Stripe per-product member price; falls back to `price`
    // (list) when unset. Populate from Stripe.
    { label_de: string; label_en: string; price: number; member_price?: number }
  >
}

export const CATALOG: CatalogData = {
  PRODUCT_SERVICES: {
    full_body_mri_core: {
      label: "Ganzkörper MRI (Core)",
      label_en: "Full-body MRI (Core)",
      tardoc_total: 2146.88,
      lines: [
        [
          "GP.00",
          "0010",
          "MR Neurokranium",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0060",
          "MR Hals",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0080",
          "MR Thorax",
          1.0,
          "",
          1.0,
          1.0,
          160.27,
          1.0,
          1.0,
          160.27,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0120",
          "MR Ganzes Abdomen",
          1.0,
          "",
          1.0,
          1.0,
          194.61,
          1.0,
          1.0,
          194.61,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0130",
          "MR Unterbauch/Becken",
          1.0,
          "",
          1.0,
          1.0,
          183.16,
          1.0,
          1.0,
          183.16,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "AR.05",
          "0080",
          "Wechselzeit Sparte Magnetresonanztomografie",
          1.0,
          "",
          1.0,
          1.0,
          57.24,
          1.0,
          1.0,
          57.24,
        ],
        [
          "GA.05",
          "0010",
          "RIS/PACS",
          1.0,
          "",
          1.0,
          1.0,
          10.36,
          1.0,
          1.0,
          10.36,
        ],
      ],
    },
    full_body_mri_advanced: {
      label: "Ganzkörper MRI (Advanced)",
      label_en: "Full-body MRI (Advanced)",
      tardoc_total: 2146.88,
      lines: [
        [
          "GP.00",
          "0010",
          "MR Neurokranium",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0060",
          "MR Hals",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0080",
          "MR Thorax",
          1.0,
          "",
          1.0,
          1.0,
          160.27,
          1.0,
          1.0,
          160.27,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0120",
          "MR Ganzes Abdomen",
          1.0,
          "",
          1.0,
          1.0,
          194.61,
          1.0,
          1.0,
          194.61,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0130",
          "MR Unterbauch/Becken",
          1.0,
          "",
          1.0,
          1.0,
          183.16,
          1.0,
          1.0,
          183.16,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "AR.05",
          "0080",
          "Wechselzeit Sparte Magnetresonanztomografie",
          1.0,
          "",
          1.0,
          1.0,
          57.24,
          1.0,
          1.0,
          57.24,
        ],
        [
          "GA.05",
          "0010",
          "RIS/PACS",
          1.0,
          "",
          1.0,
          1.0,
          10.36,
          1.0,
          1.0,
          10.36,
        ],
      ],
    },
    full_body_mri_pro: {
      label: "Ganzkörper MRI (Pro)",
      label_en: "Full-body MRI (Pro)",
      tardoc_total: 2952.37,
      lines: [
        [
          "GP.00",
          "0010",
          "MR Neurokranium",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0070",
          "MR Teilstück der Wirbelsäule",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0060",
          "MR Hals",
          1.0,
          "",
          1.0,
          1.0,
          171.72,
          1.0,
          1.0,
          171.72,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0080",
          "MR Thorax",
          1.0,
          "",
          1.0,
          1.0,
          160.27,
          1.0,
          1.0,
          160.27,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0120",
          "MR Ganzes Abdomen",
          1.0,
          "",
          1.0,
          1.0,
          194.61,
          1.0,
          1.0,
          194.61,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0200",
          "MR Hüfte und/oder Oberschenkel, pro Seite",
          1.0,
          "",
          1.0,
          1.0,
          188.89,
          1.0,
          1.0,
          188.89,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0200",
          "MR Hüfte und/oder Oberschenkel, pro Seite",
          1.0,
          "",
          1.0,
          1.0,
          188.89,
          1.0,
          1.0,
          188.89,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0210",
          "MR Kniegelenk und/oder Unterschenkel, pro Seite",
          1.0,
          "",
          1.0,
          1.0,
          177.44,
          1.0,
          1.0,
          177.44,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "GP.00",
          "0210",
          "MR Kniegelenk und/oder Unterschenkel, pro Seite",
          1.0,
          "",
          1.0,
          1.0,
          177.44,
          1.0,
          1.0,
          177.44,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0010",
          "Befundung und Berichtserstellung MR",
          1.0,
          52.82,
          1.0,
          1.0,
          21.24,
          1.0,
          1.0,
          74.06,
        ],
        [
          "AR.05",
          "0080",
          "Wechselzeit Sparte Magnetresonanztomografie",
          1.0,
          "",
          1.0,
          1.0,
          57.24,
          1.0,
          1.0,
          57.24,
        ],
        [
          "GA.05",
          "0010",
          "RIS/PACS",
          1.0,
          "",
          1.0,
          1.0,
          10.36,
          1.0,
          1.0,
          10.36,
        ],
      ],
    },
    advanced_blood_test: {
      label: "Erweiterter Bluttest",
      label_en: "Advanced blood test",
      tardoc_total: 226.5,
      lines: [
        ["317", "1006", "Vitamin D", 1.0, 38.2, 1.0, 1.0, "", 1.0, 1.0, 38.2],
        [
          "317",
          "1020",
          "Alanin-Aminotransferase (ALAT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1021", "Albumin", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1027",
          "Alkalische Phosphatase",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1047", "Amylase", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1089",
          "Apolipoprotein B",
          1.0,
          17.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          17.9,
        ],
        [
          "317",
          "1093",
          "Aspartat-Aminotransferase (ASAT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        [
          "317",
          "1206",
          "Bilirubin, direkt",
          1.0,
          3.2,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          3.2,
        ],
        [
          "317",
          "1207",
          "Bilirubin, gesamt",
          1.0,
          2.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.9,
        ],
        [
          "317",
          "1223",
          "Calcium, total",
          1.0,
          2.5,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.5,
        ],
        ["317", "1230", "Cholesterin", 0.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 0.0],
        [
          "317",
          "1245",
          "C-reaktives Protein (CRP)",
          1.0,
          8.1,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          8.1,
        ],
        ["317", "1270", "Eisen", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        ["317", "1314", "Ferritin", 1.0, 6.4, 1.0, 1.0, "", 1.0, 1.0, 6.4],
        [
          "317",
          "1341",
          "Gamma-Glutamyl-Transferase (GGT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1356", "Glukose", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1363",
          "Hämoglobin A1c",
          1.0,
          16.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          16.0,
        ],
        [
          "317",
          "1374",
          "Hämatogramm V: Erythrozyten, Hämoglobin, Hämatokrit,\nIndices, Leukozyten, 5 oder mehr\nLeukozyten-Subpopulationen und flowzytometrische\nDifferenzierung der Leukozyten und Thrombozyten",
          1.0,
          11.8,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.8,
        ],
        ["317", "1406", "Harnstoff", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1410.01",
          "HDL-Cholesterin",
          1.0,
          7.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          7.9,
        ],
        ["317", "1471", "Insulin", 1.0, 18.9, 1.0, 1.0, "", 1.0, 1.0, 18.9],
        ["317", "1479", "Kalium", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        ["317", "1509", "Kreatinin", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1518",
          "Laktat-Dehydrogenase (LDH)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        [
          "317",
          "1521",
          "LDL-Cholesterin, gemessen",
          1.0,
          3.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          3.6,
        ],
        ["317", "1537", "Lipase", 1.0, 4.5, 1.0, 1.0, "", 1.0, 1.0, 4.5],
        ["317", "1556", "Magnesium", 1.0, 7.8, 1.0, 1.0, "", 1.0, 1.0, 7.8],
        ["317", "1574", "Natrium", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        ["317", "1601", "Phosphat", 1.0, 2.9, 1.0, 1.0, "", 1.0, 1.0, 2.9],
        ["317", "1634", "Protein", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1718.1",
          "Thyreotropin (TSH)",
          1.0,
          7.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          7.3,
        ],
        [
          "317",
          "1720",
          "Thyroxin, freies (FT4)",
          1.0,
          8.1,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          8.1,
        ],
        ["317", "1729", "Transferrin", 1.0, 5.6, 1.0, 1.0, "", 1.0, 1.0, 5.6],
        ["317", "1731", "Triglyceride", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        [
          "317",
          "1732",
          "Triiodthyronin, freies (FT3)",
          1.0,
          9.4,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          9.4,
        ],
        ["317", "1738", "Harnsäure", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        [
          "317",
          "4701",
          "Blutentnahme, Kapillarblut oder Venenpunktion",
          1.0,
          5.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          5.9,
        ],
      ],
    },
    b_vitamins_blood_test: {
      label: "Essenzielle B-Vitamine Bluttest",
      label_en: "Essential B-vitamins blood test",
      tardoc_total: 29.8,
      lines: [
        [
          "317",
          "1749",
          "Vitamin B12 bzw. Cobalamin",
          1.0,
          18.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          18.0,
        ],
        [
          "317",
          "1329",
          "Folat, Blut (Vitamin B9)",
          1.0,
          11.8,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.8,
        ],
      ],
    },
    hormone_blood_test: {
      label: "Hormon-Bluttest",
      label_en: "Hormone blood test",
      tardoc_total: 129.5,
      lines: [
        ["317", "1694", "Testosteron", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
        ["317", "1307", "Estradiol", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
        [
          "317",
          "1262",
          "Dehydroepiandrosteron-Sulfat (DHEA-S)",
          1.0,
          21.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          21.6,
        ],
        [
          "317",
          "1668",
          "Sexualhormonbindendes Globulin (SHBG)",
          1.0,
          27.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          27.0,
        ],
        [
          "317",
          "1331",
          "Follitropin (FSH)",
          1.0,
          15.4,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          15.4,
        ],
        ["317", "1620", "Progesteron", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
        [
          "317",
          "1542",
          "Lutropin (LH)",
          1.0,
          13.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          13.3,
        ],
      ],
    },
    hormone_blood_test_male: {
      label: "Hormon-Bluttest",
      label_en: "Hormone blood test",
      tardoc_total: 83.4,
      lines: [
        ["317", "1694", "Testosteron", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
        ["317", "1307", "Estradiol", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
        [
          "317",
          "1262",
          "Dehydroepiandrosteron-Sulfat (DHEA-S)",
          1.0,
          21.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          21.6,
        ],
        [
          "317",
          "1668",
          "Sexualhormonbindendes Globulin (SHBG)",
          1.0,
          27.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          27.0,
        ],
      ],
    },
    psa_test: {
      label: "PSA-Test",
      label_en: "PSA test",
      tardoc_total: 10.6,
      lines: [
        [
          "317",
          "1626",
          "Prostata spezifisches Antigen (PSA)",
          1.0,
          10.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          10.6,
        ],
      ],
    },
    omega3_blood_test: {
      label: "Omega-3 & 6 Bluttest",
      label_en: "Omega-3 & 6 blood test",
      tardoc_total: 85.5,
      lines: [
        [
          "317",
          "1316",
          "Fettsäuren, freie",
          1.0,
          85.5,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          85.5,
        ],
      ],
    },
    lipoprotein_blood_test: {
      label: "Lipoprotein (a) Bluttest",
      label_en: "Lipoprotein (a) blood test",
      tardoc_total: 17.9,
      lines: [
        [
          "317",
          "1539",
          "Lipoprotein (a)",
          1.0,
          17.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          17.9,
        ],
      ],
    },
    cortisol_blood_test: {
      label: "Cortisol Bluttest",
      label_en: "Cortisol blood test",
      tardoc_total: 17.4,
      lines: [
        ["317", "1240.1", "Cortisol", 1.0, 17.4, 1.0, 1.0, "", 1.0, 1.0, 17.4],
      ],
    },
    trace_elements_blood_test: {
      label: "Spurenelemente Bluttest",
      label_en: "Trace elements blood test",
      tardoc_total: 173.7,
      lines: [
        ["317", "1767", "Zink", 1.0, 39.6, 1.0, 1.0, "", 1.0, 1.0, 39.6],
        ["317", "1665", "Selen", 1.0, 94.5, 1.0, 1.0, "", 1.0, 1.0, 94.5],
        ["317", "1515", "Kupfer", 1.0, 39.6, 1.0, 1.0, "", 1.0, 1.0, 39.6],
      ],
    },
    heavy_metals_blood_test: {
      label: "Schwermetalle Bluttest",
      label_en: "Heavy metals blood test",
      tardoc_total: 229.5,
      lines: [
        ["317", "1211", "Blei", 1.0, 121.5, 1.0, 1.0, "", 1.0, 1.0, 121.5],
        [
          "317",
          "1645",
          "Quecksilber",
          1.0,
          108.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          108.0,
        ],
      ],
    },
    coeliac_blood_test: {
      label: "Zöliakie Bluttest",
      label_en: "Coeliac blood test",
      tardoc_total: 30.8,
      lines: [
        [
          "317",
          "1132",
          "Autoantikörper gegen humane Gewebstransglutaminase",
          1.0,
          25.2,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          25.2,
        ],
        [
          "317",
          "1441",
          "Immunglobulin A (IgA)",
          1.0,
          5.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          5.6,
        ],
      ],
    },
    bvitamins_homocysteine_blood_test: {
      label: "Essenzielle B-Vitamine & Homocystein Bluttest",
      label_en: "Essential B-vitamins & homocysteine blood test",
      tardoc_total: 56.8,
      lines: [
        [
          "317",
          "1749",
          "Vitamin B12 bzw. Cobalamin",
          1.0,
          18.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          18.0,
        ],
        [
          "317",
          "1329",
          "Folat, Blut (Vitamin B9)",
          1.0,
          11.8,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.8,
        ],
        ["317", "1422", "Homocystein", 1.0, 27.0, 1.0, 1.0, "", 1.0, 1.0, 27.0],
      ],
    },
    dexa: {
      label: "DEXA",
      label_en: "DEXA",
      tardoc_total: 124.43,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.0,
          8.64,
          1.0,
          1.0,
          19.2,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          5.0,
          2.11,
          1.0,
          1.0,
          1.73,
          1.0,
          1.0,
          19.2,
        ],
        [
          "GG.20",
          "0010",
          "Osteodensitometrie, mit axialer DEXA, pro 1 Min.",
          15.0,
          "",
          1.0,
          1.0,
          2.08,
          1.0,
          1.0,
          31.2,
        ],
        [
          "GG.30",
          "0010",
          "+ Erstellung eines radiologischen Berichts zuhanden eines anderen Arztes, pro 1 Min.",
          10.0,
          2.11,
          1.0,
          1.0,
          0.85,
          1.0,
          1.0,
          29.6,
        ],
        [
          "GG.30",
          "0090",
          "Befundung Osteodensitometrie",
          1.0,
          10.56,
          1.0,
          1.0,
          4.25,
          1.0,
          1.0,
          14.81,
        ],
        [
          "AR.05",
          "0010",
          "Wechselzeit Sparte Röntgen-Osteodensitometrie",
          1.0,
          "",
          1.0,
          1.0,
          10.42,
          1.0,
          1.0,
          10.42,
        ],
      ],
    },
    breast_mri: {
      label: "Mamma-MRI",
      label_en: "Breast MRI",
      tardoc_total: 799.33,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.0,
          8.64,
          1.0,
          1.0,
          19.2,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          5.0,
          2.11,
          1.0,
          1.0,
          1.73,
          1.0,
          1.0,
          19.2,
        ],
        [
          "GP.00",
          "0090",
          "MR Mamma",
          1.0,
          "",
          1.0,
          1.0,
          188.89,
          1.0,
          1.0,
          188.89,
        ],
        [
          "GP.00",
          "0020",
          "+ Zuschlag weitere Serien MR",
          1.0,
          "",
          1.0,
          1.0,
          114.48,
          1.0,
          1.0,
          114.48,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0020",
          "Besonders aufwändige Befundung und Berichtserstellung MR, pro 1 Min.",
          35.0,
          2.11,
          1.0,
          1.0,
          0.85,
          1.0,
          1.0,
          103.6,
        ],
        [
          "GP.00",
          "0240",
          "MR Angiografie aller Gefässe",
          1.0,
          "",
          1.0,
          1.0,
          91.58,
          1.0,
          1.0,
          91.58,
        ],
        [
          "GP.00",
          "0030",
          "+ Ärztliche Leistung vor und während MR-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.27,
        ],
        [
          "GP.15",
          "0020",
          "Besonders aufwändige Befundung und Berichtserstellung MR, pro 1 Min.",
          35.0,
          2.11,
          1.0,
          1.0,
          0.85,
          1.0,
          1.0,
          103.6,
        ],
        [
          "GP.10",
          "0020",
          "Aufwändige technische Untersuchung MR, pro 1 Min.",
          12.0,
          "",
          1.0,
          1.0,
          5.72,
          1.0,
          1.0,
          68.64,
        ],
        [
          "GA.05",
          "0010",
          "RIS/PACS",
          1.0,
          "",
          1.0,
          1.0,
          10.36,
          1.0,
          1.0,
          10.36,
        ],
        [
          "AR.05",
          "0080",
          "Wechselzeit Sparte Magnetresonanztomografie",
          1.0,
          "",
          1.0,
          1.0,
          57.24,
          1.0,
          1.0,
          57.24,
        ],
      ],
    },
    heart_ct: {
      label: 'Herz-CT "Calcium Score"',
      label_en: 'Heart CT "calcium score"',
      tardoc_total: 370.28,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.1,
          8.64,
          1.0,
          1.1,
          21.12,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          5.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          21.12,
        ],
        [
          "GM.00",
          "0130",
          "CT Herz nativ mit Calcium Score",
          1.0,
          "",
          1.0,
          1.1,
          80.63,
          1.0,
          1.1,
          88.69,
        ],
        [
          "GM.10",
          "0010",
          "Aufwändige technische Untersuchung CT",
          1.0,
          22.54,
          1.0,
          1.1,
          53.75,
          1.0,
          1.1,
          83.92,
        ],
        [
          "GM.00",
          "0020",
          "+ Ärztliche Leistung vor und während CT-Untersuchung",
          1.0,
          11.27,
          1.0,
          1.1,
          "",
          1.0,
          1.1,
          12.4,
        ],
        [
          "GM.15",
          "0020",
          "Besonders aufwändige Befundung und Berichtserstellung CT, pro 1 Min.",
          25.0,
          2.11,
          1.0,
          1.1,
          0.85,
          1.0,
          1.1,
          81.4,
        ],
        [
          "AR.05",
          "0070",
          "Wechselzeit Sparte Computertomografie",
          1.0,
          "",
          1.0,
          1.1,
          22.4,
          1.0,
          1.1,
          24.64,
        ],
        [
          "GA.00",
          "0010",
          "Strahlenschutz-Pauschale für hochdosierte Bildgebung",
          1.0,
          "",
          1.0,
          1.1,
          23.27,
          1.0,
          1.1,
          25.6,
        ],
        ["GA.05", "0010", "RIS/PACS", 1.0, "", 1.0, 1.1, 10.36, 1.0, 1.1, 11.4],
      ],
    },
    advanced_blood_test_follow_up: {
      label: "Erweiterter Bluttest (Folgeuntersuchung)",
      label_en: "Advanced blood test (follow-up)",
      tardoc_total: 128.2,
      lines: [
        [
          "317",
          "1089",
          "Apolipoprotein B",
          1.0,
          17.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          17.9,
        ],
        [
          "317",
          "1410.01",
          "HDL-Cholesterin",
          1.0,
          7.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          7.9,
        ],
        [
          "317",
          "1521",
          "LDL-Cholesterin, gemessen",
          1.0,
          3.6,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          3.6,
        ],
        ["317", "1731", "Triglyceride", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        [
          "317",
          "1020",
          "Alanin-Aminotransferase (ALAT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1021", "Albumin", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        [
          "317",
          "1093",
          "Aspartat-Aminotransferase (ASAT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1314", "Ferritin", 1.0, 6.4, 1.0, 1.0, "", 1.0, 1.0, 6.4],
        [
          "317",
          "1341",
          "Gamma-Glutamyl-Transferase (GGT)",
          1.0,
          2.3,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.3,
        ],
        ["317", "1270", "Eisen", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        ["317", "1634", "Protein", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        ["317", "1729", "Transferrin", 1.0, 5.6, 1.0, 1.0, "", 1.0, 1.0, 5.6],
        [
          "317",
          "1374",
          "Hämatogramm V: Erythrozyten, Hämoglobin, Hämatokrit,\nIndices, Leukozyten, 5 oder mehr\nLeukozyten-Subpopulationen und flowzytometrische\nDifferenzierung der Leukozyten und Thrombozyten",
          1.0,
          11.8,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          11.8,
        ],
        [
          "317",
          "1245",
          "C-reaktives Protein (CRP)",
          1.0,
          8.1,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          8.1,
        ],
        ["317", "1356", "Glukose", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        ["317", "1471", "Insulin", 1.0, 18.9, 1.0, 1.0, "", 1.0, 1.0, 18.9],
        [
          "317",
          "1363",
          "Hämoglobin A1c",
          1.0,
          16.0,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          16.0,
        ],
        [
          "317",
          "1223",
          "Calcium, total",
          1.0,
          2.5,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          2.5,
        ],
        ["317", "1509", "Kreatinin", 1.0, 2.3, 1.0, 1.0, "", 1.0, 1.0, 2.3],
        ["317", "1738", "Harnsäure", 1.0, 2.5, 1.0, 1.0, "", 1.0, 1.0, 2.5],
        [
          "317",
          "4701",
          "Blutentnahme, Kapillarblut oder Venenpunktion",
          1.0,
          5.9,
          1.0,
          1.0,
          "",
          1.0,
          1.0,
          5.9,
        ],
      ],
    },
    additional_blood: {
      label: "Zusätzlicher Analysen und Bericht",
      label_en: "Additional analysis and report",
      tardoc_total: 63.36,
      lines: [
        [
          "AA.25",
          "0020",
          "Erstellung eines ärztlichen Berichts zuhanden des Patienten\noder eines Angehörigen, pro 1 Min.",
          15.0,
          2.11,
          1.0,
          1.0,
          1.73,
          1.0,
          1.1,
          63.36,
        ],
      ],
    },
    additional_core: {
      label: "Zusätzlicher Analysen und Bericht",
      label_en: "Additional analysis and report",
      tardoc_total: 126.72,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.1,
          8.64,
          1.0,
          1.1,
          21.12,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          15.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          63.36,
        ],
        [
          "AA.25",
          "0020",
          "Erstellung eines ärztlichen Berichts zuhanden des Patienten\noder eines Angehörigen, pro 1 Min.",
          10.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          42.24,
        ],
      ],
    },
    additional_advanced: {
      label: "Zusätzlicher Analysen und Bericht",
      label_en: "Additional analysis and report",
      tardoc_total: 278.96,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.1,
          8.64,
          1.0,
          1.1,
          21.12,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          15.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          63.36,
        ],
        [
          "AA.25",
          "0020",
          "Erstellung eines ärztlichen Berichts zuhanden des Patienten\noder eines Angehörigen, pro 1 Min.",
          20.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          84.48,
        ],
        [
          "999",
          "0002",
          "Quantitative MRI zur Bestimmung von Leberfett (&PDFF) und\nEisenablagerung (R2*)",
          1.0,
          "",
          1.0,
          1.1,
          50.0,
          1.0,
          1.1,
          55.0,
        ],
        [
          "999",
          "0003",
          "Zusätzliche MRI-Parametrisierung (Abdominales fett,\nMuskelfettinfiltration)",
          1.0,
          "",
          1.0,
          1.1,
          50.0,
          1.0,
          1.1,
          55.0,
        ],
      ],
    },
    additional_pro: {
      label: "Zusätzlicher Analysen und Bericht",
      label_en: "Additional analysis and report",
      tardoc_total: 431.2,
      lines: [
        [
          "AA.10",
          "0010",
          "Ärztliche, telemedizinische zeitgleiche Konsultation, erste 5 Min.",
          1.0,
          10.56,
          1.0,
          1.1,
          8.64,
          1.0,
          1.1,
          21.12,
        ],
        [
          "AA.10",
          "0020",
          "+ Ärztliche, telemedizinische zeitgleiche Konsultation, jede weitere 1 Min.",
          15.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          63.36,
        ],
        [
          "AA.25",
          "0020",
          "Erstellung eines ärztlichen Berichts zuhanden des Patienten\noder eines Angehörigen, pro 1 Min.",
          30.0,
          2.11,
          1.0,
          1.1,
          1.73,
          1.0,
          1.1,
          126.72,
        ],
        [
          "999",
          "0001",
          "KI-gestützte Gehirnvolumetrie und Läsionsanalyse",
          1.0,
          "",
          1.0,
          1.1,
          100.0,
          1.0,
          1.1,
          110.0,
        ],
        [
          "999",
          "0002",
          "Quantitative MRI zur Bestimmung von Leberfett (&PDFF) und\nEisenablagerung (R2*)",
          1.0,
          "",
          1.0,
          1.1,
          50.0,
          1.0,
          1.1,
          55.0,
        ],
        [
          "999",
          "0003",
          "Zusätzliche MRI-Parametrisierung (Abdominales fett,\nMuskelfettinfiltration)",
          1.0,
          "",
          1.0,
          1.1,
          50.0,
          1.0,
          1.1,
          55.0,
        ],
      ],
    },
  },
  PACKAGES: {
    blood_only: {
      label: "Blood Only",
      cover_products: ["advanced_blood_test"],
      tardoc_services: ["advanced_blood_test", "additional_blood"],
    },
    blood_followup: {
      label: "Blood Follow-up",
      cover_products: ["followup_blood_test"],
      tardoc_services: ["advanced_blood_test_follow_up", "additional_blood"],
    },
    membership_1x: {
      label: "Ahead Membership 1x/Jahr",
      cover_products: ["advanced_blood_test"],
      tardoc_services: ["advanced_blood_test", "additional_blood"],
    },
    membership_2x: {
      label: "Ahead Membership 2x/Jahr",
      cover_products: ["advanced_blood_test", "advanced_blood_test_follow_up"],
      tardoc_services: ["advanced_blood_test", "additional_blood"],
    },
    membership_4x: {
      label: "Ahead Membership 4x/Jahr",
      cover_products: [
        "advanced_blood_test",
        "advanced_blood_test_follow_up",
        "advanced_blood_test_follow_up",
        "advanced_blood_test_follow_up",
      ],
      tardoc_services: ["advanced_blood_test", "additional_blood"],
    },
    core: {
      label: "Ahead Core",
      cover_products: ["ahead_core"],
      tardoc_services: ["full_body_mri_core", "additional_core"],
    },
    advanced: {
      label: "Ahead Advanced",
      cover_products: ["ahead_advanced"],
      tardoc_services: [
        "full_body_mri_advanced",
        "advanced_blood_test",
        "additional_advanced",
      ],
    },
    pro: {
      label: "Ahead Pro",
      cover_products: ["ahead_pro"],
      tardoc_services: [
        "full_body_mri_pro",
        "advanced_blood_test",
        // B12, folate and homocysteine — replaced the B12 + folate panel in CH
        // (AHD-12960).
        "bvitamins_homocysteine_blood_test",
        "hormone_blood_test",
        "psa_test",
        "additional_pro",
      ],
    },
  },
  ADDONS: {
    advanced_blood_test: {
      cover: "advanced_blood_test",
      tardoc: "advanced_blood_test",
    },
    followup_blood_test: {
      cover: "followup_blood_test",
      tardoc: "advanced_blood_test_follow_up",
    },
    b_vitamins_blood_test: {
      cover: "b_vitamins_blood_test",
      tardoc: "b_vitamins_blood_test",
    },
    hormone_blood_test: {
      cover: "hormone_blood_test",
      tardoc: "hormone_blood_test",
    },
    omega3_blood_test: {
      cover: "omega3_blood_test",
      tardoc: "omega3_blood_test",
    },
    lipoprotein_blood_test: {
      cover: "lipoprotein_blood_test",
      tardoc: "lipoprotein_blood_test",
    },
    cortisol_blood_test: {
      cover: "cortisol_blood_test",
      tardoc: "cortisol_blood_test",
    },
    trace_elements_blood_test: {
      cover: "trace_elements_blood_test",
      tardoc: "trace_elements_blood_test",
    },
    heavy_metals_blood_test: {
      cover: "heavy_metals_blood_test",
      tardoc: "heavy_metals_blood_test",
    },
    coeliac_blood_test: {
      cover: "coeliac_blood_test",
      tardoc: "coeliac_blood_test",
    },
    bvitamins_homocysteine_blood_test: {
      cover: "bvitamins_homocysteine_blood_test",
      tardoc: "bvitamins_homocysteine_blood_test",
    },
    psa_test: {
      cover: "psa_test",
      tardoc: "psa_test",
    },
    dexa: {
      cover: "dexa",
      tardoc: "dexa",
    },
    breast_mri: {
      cover: "breast_mri",
      tardoc: "breast_mri",
    },
    heart_ct: {
      cover: "heart_ct",
      tardoc: "heart_ct",
    },
  },
  BLOOD_TEST_SERVICES: [
    "hormone_blood_test_male",
    "advanced_blood_test",
    "hormone_blood_test",
    "omega3_blood_test",
    "cortisol_blood_test",
    "lipoprotein_blood_test",
    "psa_test",
    "advanced_blood_test_follow_up",
    "b_vitamins_blood_test",
    "trace_elements_blood_test",
    "heavy_metals_blood_test",
    "coeliac_blood_test",
    "bvitamins_homocysteine_blood_test",
  ],
  TARDOC_ORDER: [
    "full_body_mri_core",
    "full_body_mri_advanced",
    "full_body_mri_pro",
    "advanced_blood_test",
    "advanced_blood_test_follow_up",
    "b_vitamins_blood_test",
    "hormone_blood_test",
    "hormone_blood_test_male",
    "omega3_blood_test",
    "lipoprotein_blood_test",
    "cortisol_blood_test",
    "trace_elements_blood_test",
    "heavy_metals_blood_test",
    "coeliac_blood_test",
    "bvitamins_homocysteine_blood_test",
    "psa_test",
    "dexa",
    "breast_mri",
    "heart_ct",
    "additional_blood",
    "additional_core",
    "additional_advanced",
    "additional_pro",
  ],
  MEMBERSHIP_FOLLOWUP_COUNTS: {
    membership_2x: 1,
    membership_4x: 3,
  },
  FOLLOWUP_TARDOC_SERVICE: "advanced_blood_test_follow_up",
  GENDER_RULES: {
    male: {
      tardoc_swap: {
        hormone_blood_test: "hormone_blood_test_male",
      },
      exclude: ["breast_mri"],
    },
    female: {
      tardoc_swap: {},
      exclude: ["psa_test"],
    },
  },
  PRODUCT_PRICES: {
    ahead_core: {
      label_de: "Ahead Core",
      label_en: "Ahead Core",
      price: 1990.0,
      member_price: 1890,
    },
    ahead_advanced: {
      label_de: "Ahead Advanced",
      label_en: "Ahead Advanced",
      price: 2490.0,
      member_price: 2290,
    },
    ahead_pro: {
      label_de: "Ahead Pro",
      label_en: "Ahead Pro",
      price: 3549.0,
      member_price: 3290,
    },
    advanced_blood_test: {
      label_de: "Erweiterter Bluttest",
      label_en: "Advanced blood test",
      price: 299.0,
      member_price: 279,
    },
    advanced_blood_test_follow_up: {
      label_de: "Erweiterter Bluttest (Folgeuntersuchung)",
      label_en: "Advanced blood test (follow-up)",
      // The follow-up bundled into 2x/4x memberships — the 200 IS the membership
      // price (member == list here). The standalone follow-up is
      // `followup_blood_test` (250 list / 239 member).
      price: 200.0,
      member_price: 200.0,
    },
    followup_blood_test: {
      label_de: "Erweiterter Bluttest (Folgeuntersuchung)",
      label_en: "Advanced blood test (follow-up)",
      price: 250.0,
      member_price: 239,
    },
    hormone_blood_test: {
      label_de: "Hormon-Bluttest",
      label_en: "Hormone blood test",
      price: 149.0,
      member_price: 119,
    },
    b_vitamins_blood_test: {
      label_de: "Essenzielle B-Vitamine Bluttest",
      label_en: "Essential B-vitamins blood test",
      price: 49.0,
      member_price: 39,
    },
    omega3_blood_test: {
      label_de: "Omega-3 & 6 Bluttest",
      label_en: "Omega-3 & 6 blood test",
      price: 129.0,
      member_price: 119,
    },
    lipoprotein_blood_test: {
      label_de: "Lipoprotein (a) Bluttest",
      label_en: "Lipoprotein (a) blood test",
      price: 29.0,
      member_price: 25,
    },
    cortisol_blood_test: {
      label_de: "Cortisol Bluttest",
      label_en: "Cortisol blood test",
      price: 29.0,
      member_price: 25,
    },
    trace_elements_blood_test: {
      label_de: "Spurenelemente Bluttest",
      label_en: "Trace elements blood test",
      price: 225.0,
      member_price: 209,
    },
    heavy_metals_blood_test: {
      label_de: "Schwermetalle Bluttest",
      label_en: "Heavy metals blood test",
      price: 285.0,
      member_price: 269,
    },
    coeliac_blood_test: {
      label_de: "Zöliakie Bluttest",
      label_en: "Coeliac blood test",
      price: 49.0,
      member_price: 39,
    },
    bvitamins_homocysteine_blood_test: {
      label_de: "Essenzielle B-Vitamine & Homocystein Bluttest",
      label_en: "Essential B-vitamins & homocysteine blood test",
      price: 89.0,
      member_price: 79,
    },
    psa_test: {
      label_de: "PSA Bluttest",
      label_en: "PSA blood test",
      price: 19.0,
      member_price: 15,
    },
    dexa: {
      label_de: "DEXA-Scan",
      label_en: "DEXA scan",
      price: 135.0,
      member_price: 119,
    },
    breast_mri: {
      label_de: "Mamma-MRI",
      label_en: "Mamma MRI",
      price: 800.0,
      member_price: 749,
    },
    heart_ct: {
      label_de: 'Herz-CT "Calcium Score"',
      label_en: 'Heart CT "calcium score"',
      price: 470.0,
      member_price: 439,
    },
  },
}
